import { IconCodePlus } from '@rossum/ui/icons/tabler';
import { IconButton, SvgIcon } from '@rossum/ui/material';

export const SuggesterIconButton = ({
  disabled,
  svgColor,
  dataCy,
  ...props
}: {
  disabled?: boolean;
  svgColor?: string;
  dataCy?: string;
}) => {
  const svgSX = svgColor ? { color: svgColor } : undefined;
  return (
    <IconButton type="button" size="small" disabled={disabled} {...props}>
      <SvgIcon fontSize="medium" sx={svgSX}>
        <IconCodePlus data-cy={dataCy} />
      </SvgIcon>
    </IconButton>
  );
};
